<template>
  <v-form @submit.prevent>
    <tiles-form :doc="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
    <pre>
        {{ doc }}
      </pre
    >
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form";
import router from "@/router";

export default {
  name: "AdminProjectAdd",
  components: {
    TilesForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let ref = this.$parent.collection.doc();
      console.log(this.doc);
      ref
        .set({
          createdOn: new Date(),
          id: ref.id,
          title: this.doc.title,
          description: this.doc.description,
          users: this.doc.users,
          showResults: this.populateField(this.doc.showResults),
          exercisesOrder: this.populateField(this.doc.exercisesOrder),
          benchmarksOrder: this.populateField(this.doc.benchmarksOrder),
          planesOrder: this.populateField(this.doc.planesOrder),
          functionalityOrder: this.populateField(this.doc.functionalityOrder),
        })
        .then(() => {
          router.push({ name: this.$parent.returnRoute });
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    populateField(field) {
      return field ? field : null;
    },
  },
};
</script>
